import queryString from 'query-string';
import { errorToast } from '../../utils/toast';
import { aws_bucket, baseURL, env } from '../../components/config';

export const getUploadUrl = async (file, module, recordID) => {
  const params = {
    bucket: aws_bucket,
    ContentType: file?.file?.type,
    Key: env + `/${module}/` + recordID + '/' + file.display_name,
  };
  const response = await fetch(`${baseURL}/generate-put-url?${queryString.stringify(params)}`, {
    headers: {
      'Content-Type': params.ContentType,
    },
  });
  return response.json();
};

export const uploadFileToS3 = async (uploadUrl, file, contentType) => {
  const response = await fetch(uploadUrl.putURL, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': contentType,
    },
  });
  if (response.status !== 200) {
    errorToast('File upload failed.');
    throw new Error('File upload failed.');
  }
};
